var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "entity-info-card-container" }, [
    _c("header", [
      _c("div", { staticClass: "header_left" }),
      _vm._v(" "),
      _c("div", { staticClass: "header_right" }, [
        _c("div", { staticClass: "header" }, [_vm._v(_vm._s(_vm.header))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "entity-detail-container" }, [
      _c("h4", { staticClass: "name" }, [_vm._v(_vm._s(_vm.entityName))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "div-table" },
        _vm._l(_vm.orderedItems, function (item, idx) {
          return _c(
            "div",
            {
              key: `entity-info-card-item-${idx}`,
              staticClass: "div-table-row",
            },
            [
              _c("div", { staticClass: "div-table-col-key" }, [
                _vm._v(_vm._s(_vm.$t(`${item.name}`)) + ":"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "div-table-col-value" }, [
                _vm._v(_vm._s(item.value ?? _vm.itemValue(item.key))),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.actionAllow
        ? _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onAction.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "btn-wrapper" }, [
                _c("i", { class: ["icon", _vm.btnIcon] }),
                _vm._v(" "),
                _c("p", { staticClass: "text-icon" }, [
                  _vm._v(_vm._s(_vm.actionTxt)),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }